import { FormErrors } from 'redux-form'
import i18next from 'i18next'
import { ELEMENT_ATTRIBUTES } from '../../../utils/enums'

export default (values: any) => {
	const errors: FormErrors<any> = {}

	if (values?.[ELEMENT_ATTRIBUTES.IS_AUTOCOMPLETE] && !values?.[ELEMENT_ATTRIBUTES.PROCEDURE_AUTOCOMPLETE_DROPDOWN]) {
		errors[ELEMENT_ATTRIBUTES.PROCEDURE_AUTOCOMPLETE_DROPDOWN] = i18next.t('loc:Toto pole je povinné') as string
	}
	return errors
}
